import React from "react";
import { Link, useLocation } from "react-router-dom";
import * as FeatherIcon from "react-feather";
import { useUser } from "../../context/UserContext";

export default function UserPreferenceSidebar({
  activeSection,
  onSectionClick,
}) {
  var pathname = useLocation().pathname;
  var progress_bar_width = 33;

  const { user } = useUser();
  const current_role_key = user?.role_key;

  if (pathname === "/user_profile/profile") {
    progress_bar_width = 33;
  } else if (pathname === "/user_profile/business_segment") {
    progress_bar_width = 66;
  } else if (pathname === "/user_profile/company_profile") {
    progress_bar_width = 100;
  }
  return (
    <div>
      <div className="progress_bar_block mb-2">
        <h5 className="progress_head">User profile</h5>
        {/* <div className="progress">
          <div className="progress-bar bg-success" style={{width:progress_bar_width+'%'}}></div>
        </div> */}
      </div>

      <ul className="profile_sidebar_ul">
        <li
          className={`profile_sidebar_li ${
            pathname === "/users/view_profile" && activeSection === "personal"
              ? "active"
              : ""
          }`}
        >
          <Link
            className="link_sidebar"
            to={{ pathname: "/users/view_profile" }}
            onClick={() => onSectionClick("personal")}
          >
            <FeatherIcon.UserCheck className="img_trend" /> Personal
          </Link>
        </li>

        <li
          className={`profile_sidebar_li ${
            pathname === "/users/view_profile" &&
            activeSection === "system-settings"
              ? "active"
              : ""
          }`}
        >
          <Link
            className="link_sidebar"
            to={{ pathname: "/users/view_profile" }}
            onClick={() => onSectionClick("system-settings")}
          >
            <FeatherIcon.Settings className="img_trend" /> System Settings
          </Link>
        </li>

        {/* <li className={`profile_sidebar_li ${pathname === '/users/change_password' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/users/change_password" }}><FeatherIcon.Key className='img_trend' /> Change Password</Link>
        </li> */}

        {/* <li className={`profile_sidebar_li ${pathname === '/users/personalisation' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/users/personalisation" }}><FeatherIcon.Key className='img_trend' /> Memory</Link>
        </li> */}

        {/* {(current_role_key === 'CLIENT_EMPLOYEE' 
          || current_role_key === 'CLIENT')
          && (<li className={`profile_sidebar_li ${pathname === '/users/upload_documents' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/users/upload_documents" }}><FeatherIcon.FileText className='img_trend' /> Documents</Link>
        </li>)} */}

        {/* <li className={`profile_sidebar_li ${pathname === '/user_profile/company_profile' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/user_profile/company_profile" }}><FeatherIcon.Briefcase className='img_trend' /> Select Accounts</Link>
        </li> */}
        {/* <li className='profile_sidebar_li'><a href="#" className='link_sidebar'><img src="/img/icons/profile/industry.png" className="img_trend" alt="profile"/> Enter business segments</a></li> */}
      </ul>
    </div>
  );
}
